import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    align-items: center;

    > svg {
        font-size: 1.8rem;
    }
`;

export const Title = styled.h1`
    margin: 0;
    font-size: 2rem;
    margin-left: 0.5rem;
`;
export const Subtitle = styled.h2`
    color: #777;
    margin-top: 0.5rem;
    font-size: 1.3rem;
    border-bottom: 1px solid #dedede;
`;
